import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsPforte,
        selectKindOfColorPforte,
        selectColorPforte,
        selectWishColorPforte
        } from '../../../../store/actions/pforten';
import {InputRadio} from '../../../../module/inputRadio';
import {Textfield} from '../../../../module/textField';
import {colors} from '../../../../../assets/images/data';
import scrollToElement from '../../../../module/scrollToElement';


const Step_3 = (props) => {
    const [kindOfColor, selectKindOfColor] = useState('');
    const [wishColor, selectWishcolor] = useState('');
    const [colorIndex, selectColorIndex] = useState('');


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        let {kind_of_color, wish_color, color_index, color} = props.data.colors[0];
        let color_wrapper = document.querySelectorAll('.color-wrapper');

        for(let i=0; i<color_wrapper.length; i++) {
            color_wrapper[i].classList.remove('check');
        }

        if (color_wrapper[color_index]) {
            color_wrapper[color_index].classList.add('check');
            selectColorIndex(color_index);
        }
        if (wish_color && color_wrapper[color_index]) color_wrapper[color_index].classList.remove('check');

        selectKindOfColor(kind_of_color);
        selectWishcolor(wish_color);

        //scroll to Next Button Container
        scrollToElement();

        //update step
        props.updateSteps(2);
        if(color || kind_of_color === 'Nur feuerverzinkt')  props.updateSteps(3);

         //Weiter-Button aktivieren
        if(color || kind_of_color === 'Nur feuerverzinkt' || props.data.allVisitedSteps) {
            props.updateSteps(3);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }
   }

   const updateKindOfColor = ev => {
       let kind_of_color = ev.target.value;
       props.selectKindOfColor(kind_of_color);
       updateItems();
   }

   const selectColor = ev => {
       let color = ev.currentTarget.getAttribute('titel');
       let index = ev.currentTarget.getAttribute('index');
       let colorObject = {
           color: color,
           index: index
       }
       props.selectColor(colorObject);
       updateItems();
   }

   const selectWishColor = ev => {
       let wish_color = ev.target.value;
        props.selectColor({color: wish_color, index: colorIndex});
        props.selectWishColor(wish_color);
        updateItems();
   }

   const arrayRadioItems = [
       {labalValue: 'Feuerverzinkt und pulverbeschichtet', labelTitel: 'Feuerverzinkt und pulverbeschichtet'},
       {labalValue: 'Nur feuerverzinkt', labelTitel: 'Nur feuerverzinkt'}
   ]

    return (
        <div className="step_wrapper">
            <h2 className='step_header'>Welche Beschichtung wünschen Sie sich für Ihre Pforte?</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper">
                    <InputRadio
                        onChange={updateKindOfColor}
                        value={kindOfColor}
                        name='color'
                        arial_label='Beschichtung'
                        arrayRadioItems={arrayRadioItems}
                    />
                </div>
                {kindOfColor === 'Feuerverzinkt und pulverbeschichtet' ?
                     <>
                     <div className="inner-color-wrapper">
                        {colors.map((elem, index) => (
                           <div className="color-wrapper" key={index} onClick={selectColor} name='box' index={index} titel={elem.titel}>
                              <div className="color-box" style={{background: `#${elem.color}`}}></div>
                              <p className="pColors">{elem.titel}</p>
                           </div>
                        ))}
                     </div>
                     <div className='inner_textfield_wrapper'>
                        <Textfield
                            label='Andere Farbe'
                            type='text'
                            rowsMax={1}
                            value={wishColor}
                            onChange={selectWishColor}
                        />
                    </div>
                  </>
                  : ''
                }
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.pfortenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsPforte(ev)),
      selectKindOfColor: ev => dispatch(selectKindOfColorPforte(ev)),
      selectColor: ev => dispatch(selectColorPforte(ev)),
      selectWishColor: ev => dispatch(selectWishColorPforte(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_3);
